import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-listagem-ajustes',
  templateUrl: './listagem-ajustes.component.html',
  styleUrls: ['./listagem-ajustes.component.scss'],
})
export class ListagemAjustesComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
